import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'cx-paragraph',
    templateUrl: './kb-paragraph.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KbParagraphComponent {
  protected sanitizer = inject(DomSanitizer);

 

  constructor(
    public component: CmsComponentData<CmsParagraphComponent>,
    protected router: Router) { }

  public bypassSecurityTrustHtml(html: string = ''): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
